export type FounderStatus = 'active' | 'expired';

export type FounderPlan = 'connection' | 'legacy';

export interface FoundingMember {
  id: string;
  user_id: string;
  founder_status: FounderStatus;
  slot_number: number;
  qualified_at: string;
  expired_at: string | null;
  last_out_of_announcements_date: string | null;
  bonus_credits_granted: boolean;
  early_access_enabled: boolean;
  last_reminder_sent_at: string | null;
  last_reminder_day: number | null;
  reminder_dismissed_at: string | null;
  current_plan: FounderPlan;
  legacy_upgraded_at: string | null;
  legacy_downgraded_at: string | null;
  created_at: string;
  updated_at: string;
}

export const FOUNDER_CONFIG = {
  maxSlots: 150,
  phase1Cap: 75,
  phase2Cap: 75,
  phase1Price: 12,
  phase2Price: 15,
  standardPrice: 17,
  savingsPerReload: 5,
  bonusCredits: 3,
  gracePeriodDays: 30,
  reminderDays: [7, 3, 1] as const,
  dismissDurationHours: 24,
} as const;

/** Returns days remaining in the 30-day grace window, or null if not applicable */
export function getFounderGraceDaysRemaining(
  lastOutDate: string | null
): number | null {
  if (!lastOutDate) return null;
  const outDate = new Date(lastOutDate);
  const now = new Date();
  const diffMs = now.getTime() - outDate.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const remaining = FOUNDER_CONFIG.gracePeriodDays - diffDays;
  return remaining > 0 ? remaining : 0;
}
